import {Component, OnDestroy, OnInit , ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Filters, Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {CustomInputEditor} from '../custom-inputEditor';
import {NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
    selector: 'app-role-action',
    templateUrl: './role-action.component.html',
    styleUrls: ['./role-action.component.css']
})
export class RoleActionComponent implements OnInit, OnDestroy {

    displayed = true;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;

    clientSelected: number;
    clients: any[];
    role: any[];
    roleName: string;
    roleSelected: number;
    actions: any[];
    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;
    clientId: number;
    notAdmin = true;

    private clientName: any;

    private notifier: NotifierService;
    private baseFlag: any;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private userAuth: Subscription;
    private adminAuth: Subscription;
    dataLoaded: boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    roleSelect: any;
    rolesAction: any;
    name: string;
    showExportBtn = false;
    dataExcel = [];
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;



    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {

                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (this.baseFlag) {
                        if (!this.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            if (confirm('Are you sure?')) {
                                this.deleteItem(item);
                            }
                        }
                    } else {
                        if (!this.messageService.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            if (confirm('Are you sure?')) {
                                this.deleteItem(item);
                            }
                        }
                    }
                    break;
            }
        });

        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
    }

    deleteItem(item) {
        this._rest.deleteUsrActionMapping({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.messageService.sendAfterDelete(item.id);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.respObject.errorMessage);
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        // console.log(this.messageService.pageSize);
        this.pageSize = this.messageService.pageSize;
        this.paginationType = 'next';
        this.page_no = 0;
        this.totalPage = 0;
        this.displayData = {
            pageName: 'Maintain Role  Mapping with Action',
            openModalButton: 'Map Action With Role',
            breadcrumb: 'RoleAction',
            searchModalButton: 'Search',

            folderName: 'All Mapped Action with role',
            tabName: 'Role Action Mapping',
            exportBtn: 'Export to excel'

        };

        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'client', name: 'Client ', field: 'client', sortable: true, filterable: true
            },
            {
                id: 'role', name: 'Role', field: 'role', sortable: true, filterable: true
            },
            {
                id: 'action', name: 'Action', field: 'action', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
        this._rest.getActions().subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                for (let i = 0; i < this.respObject.actions.length; i++) {
                    this.respObject.actions.checked = false;
                }
                this.actions = this.respObject.actions;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });

    }

    onPageLoad() {
        // this._rest.getUserdetails(Number(sessionStorage.getItem('id'))).subscribe((res) => {
        //   this.respObject = res;
        //   if (this.respObject.success) {
        //     this.clientId = this.respObject.details[0].clientId;
        //     this.baseFlag = this.respObject.details[0].baseFlag;
        if (this.baseFlag) {
            this.notAdmin = false;
            this._rest.getClient().subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.isError = false;
                    this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                    this.clients = this.respObject.clients;
                    this.clientSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.clientSelected = this.clientId;
            this._rest.getRoleClientWise(this.clientSelected).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.isError = false;
                    this.respObject.roles.unshift({id: 0, name: 'Select Role'});
                    this.role = this.respObject.roles;
                    this.roleSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        }
        this.getTableData();
        //   } else {
        //     this.notifier.notify('error', this.respObject.errorMessage);
        //   }
        // }, (err) => {
        //   this.notifier.notify('error', this.messageService.SERVER_ERROR);
        // });
    }


//   exportToExcel() {
//     // console.log("okkk" +this.clientId);
//     this._rest.getAllRoleActionMappingData(this.clientId).subscribe((res1) => {
//         this.respObject = res1;
//         if (this.respObject.success) {
//             this.dataExcel = this.respObject.details;
//             console.log("true"+ JSON.stringify(this.dataExcel));
//             this.messageService.exportAsExcelFile(this.dataExcel);
//         } else {
//             this.notifier.notify('error', this.respObject.errorMessage);
//         }
//     }, (err) => {
//         this.notifier.notify('error', this.messageService.SERVER_ERROR);
//     });
// }


    openModal(content) {
        for (let j = 0; j < this.actions.length; j++) {
            this.actions[j].checked = false;
        }
        if (this.baseFlag) {
            if (!this.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.clientSelected = 0;
                this.roleSelected = 0;

                this.modalService.open(content, {size: 'sm'}).result.then((result) => {
                }, (reason) => {

                });
            }
        } else {
            if (!this.messageService.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.roleSelected = 0;

                this.modalService.open(content, {size: 'sm'}).result.then((result) => {
                }, (reason) => {

                });
            }
        }
    }


    searchModal() {
        if (this.baseFlag) {
                
                this.roleSelect = '';
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
    
                });
            
        } else {
                this.roleSelect = '';
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
    
                });
            
        }
    }


    search() {
        this._rest.searchAllRoleActionMap(this.roleSelect, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.rolesAction = this.respObject.details;
                this.page_no = 1;
                this.messageService.setTotalData(this.rolesAction.length);
                this.messageService.setGridData(this.rolesAction);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    get selectedOptions() {
        return this.actions
            .filter(opt => opt.checked)
            .map(opt => opt.id);

    }


    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        const data = {
                clientId: this.clientSelected,
                roleId: this.roleSelected,
                createdBy: this.messageService.getUserId(),
                actionIds: this.selectedOptions
            };
        if (this.clientSelected !== 0 && this.roleSelected !== 0 && this.selectedOptions.length > 0) {
            this._rest.mapRoleAction(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    if (this.baseFlag) {
                        this.clientSelected = 0;
                    }
                    this.roleSelected = 0;
                    for (let j = 0; j < this.actions.length; j++) {
                        this.actions[j].checked = false;
                    }
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getTableData() {
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        console.log('get Data');
        if (this.baseFlag) {
            if (!this.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this._rest.getUsrActionMapping(offset, this.pageSize, paginationType).subscribe((res) => {
                    this.respObject = res;
                    console.log(JSON.stringify(this.respObject));
                    this.executeResponse(this.respObject, offset, paginationType);
                }, (err) => {
                    this.notifier.notify('error', this.respObject.errorMessage);
                });
            }
        } else {
            if (!this.messageService.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this._rest.getUsrActionMappingWithClientId(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
                    this.respObject = res;
                    this.executeResponse1(this.respObject, offset, paginationType);
                }, (err) => {
                    this.notifier.notify('error', this.respObject.errorMessage);
                });
            }
        }
    }

    executeResponse(respObject, offset, paginationType) {
        console.log('====================' + respObject);
        if (respObject.success) {
            console.log('======' + respObject);
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.usrAction.totalData[0].count;
                this.totalPage = respObject.usrAction.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.usrAction.dataObj)) {
                const data = respObject.usrAction.dataObj;
                this.nextOffset = respObject.usrAction.nextOffset;
                this.previousOffset = respObject.usrAction.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.usrAction.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.usrAction.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    executeResponse1(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


    onClientChange(value: any) {
        this.clientName = this.clients[value].name;
        this._rest.getRoleClientWise(this.clientSelected).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.roles.unshift({id: 0, name: 'Select Role'});
                this.role = this.respObject.roles;
                this.roleSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onRoleChange(selectedIndex: any) {
        this.roleName = this.role[selectedIndex].name;
        this._rest.getRoleWiseActions(this.clientSelected, this.roleSelected).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                if (this.respObject.details.length > 0) {
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        for (let j = 0; j < this.actions.length; j++) {
                            if (this.respObject.details[i].id === this.actions[j].id) {
                                this.actions[j].checked = true;
                                break;
                            }
                        }
                    }
                } else {
                    for (let j = 0; j < this.actions.length; j++) {
                        this.actions[j].checked = false;
                    }
                }
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onPageSizeChange(value: any) {
        this.nextOffset = 0;
        this.page_no = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
